import React from 'react';

const LandingHeroBackground: React.FC = () => (
  <div className="absolute inset-0 overflow-hidden">
    <div className="absolute -right-32 -top-32 w-[400px] h-[400px] sm:-right-48 sm:-top-48 sm:w-[600px] sm:h-[600px] lg:-right-64 lg:-top-64 lg:w-[800px] lg:h-[800px] bg-gradient-to-r from-sky-500/6 to-cyan-500/6 rounded-full mix-blend-soft-light"></div>
    <div className="absolute -left-32 -bottom-32 w-[400px] h-[400px] sm:-left-48 sm:-bottom-48 sm:w-[600px] sm:h-[600px] lg:-left-64 lg:-bottom-64 lg:w-[800px] lg:h-[800px] bg-gradient-to-r from-indigo-500/5 to-cyan-500/5 rounded-full mix-blend-soft-light"></div>
    <div className="absolute inset-0 bg-grid-white/[0.015] bg-[length:40px_40px] opacity-35"></div>
    <div className="absolute inset-0 bg-slate-950/45"></div>
  </div>
);

export default LandingHeroBackground;
